import { Flex, Form, notification } from 'antd';
import Toast from 'components/shared/Alert';
import { useLanguage } from 'hooks/Languages/useLanguage';
import LoginPage from 'pages/auth/login';
import { fetchUserPermission, onLoginUser } from 'queries/auth/user';
import { fetchAllCountry } from 'queries/default/default';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import urls, { pageFeatures } from 'routes/urls';

const isAdminAccount = 1;

const LoginPageContainer = () => {
  const navigate = useNavigate();
  const { translate } = useLanguage();
  const [form] = Form.useForm();
  const [isAdminFirstLogin, setIsAdminFirstLogin] = useState<boolean>(false);
  const [isUserFirstLogin, setIsUserFirstLogin] = useState<boolean>(false);
  const [api, contextHolder] = notification.useNotification();
  const [selectedCountry, setSelectedCountry] = useState<any>(null);

  const {
    loading,
    isError,
    isSuccess,
    message,
    submitData,
    data,
    accessToken,
    refreshToken,
    clearData: clearLoginRequest,
  } = onLoginUser();

  const { countries } = fetchAllCountry();
  const { userPermission, isLoadingPermission } = fetchUserPermission();

  const userInfo = data && data?.data;

  const countryList = countries?.map(
    (country: {
      name: string;
      id: number;
      phone_code: string;
      country_code: string;
      country_flag: string;
    }) => ({
      label: (
        <Flex gap="small">
          <span>{country.country_flag}</span>
          <span>{country?.country_code}</span>
        </Flex>
      ),
      value: country?.id,
      phoneCode: country.phone_code,
    })
  );

  const onHandleSubmit = async () => {
    try {
      const formData = await form.validateFields();

      const savedUsername = localStorage.getItem('savedUsername');
      const savedPassword = localStorage.getItem('savedPassword');

      if (formData.remember) {
        if (
          formData.username !== savedUsername ||
          formData.password !== savedPassword
        ) {
          localStorage.setItem('savedUsername', formData.username);
          localStorage.setItem('savedPassword', formData.password);
          localStorage.setItem('isRemember', 'YES');
        }
      } else {
        localStorage.removeItem('savedUsername');
        localStorage.removeItem('savedPassword');
        localStorage.setItem('isRemember', 'NO');
      }
      const payload = {
        username: !selectedCountry
          ? formData?.username
          : `${selectedCountry}${formData?.username}`,
        password: formData?.password,
        otp: formData?.otp || '',
        new_password: formData?.new_password || '',
      };
      submitData(payload);
    } catch (error) {
      Toast(api, 'Error', translate('Validation Failed'));
    }
  };

  console.log(selectedCountry, 'OOOOOOO');

  const onHandleAutoLogin = async () => {
    try {
      const formData = await form.validateFields();

      const savedUsername = localStorage.getItem('savedUsername');
      const savedPassword = localStorage.getItem('savedPassword');

      if (formData.remember) {
        if (
          formData.username !== savedUsername ||
          formData.password !== savedPassword
        ) {
          localStorage.setItem('savedUsername', formData.username);
          localStorage.setItem('savedPassword', formData.password);
          localStorage.setItem('isRemember', 'YES');
        }
      } else {
        localStorage.removeItem('savedUsername');
        localStorage.removeItem('savedPassword');
        localStorage.setItem('isRemember', 'NO');
      }
      const payload = {
        username: !selectedCountry
          ? formData?.username
          : `${selectedCountry}${formData?.username}`,
        password: formData?.new_password,
        otp: '',
        new_password: '',
      };
      submitData(payload);
    } catch (error) {
      Toast(api, 'Error', translate('Validation Failed'));
    }
  };

  useEffect(() => {
    const username = localStorage.getItem('savedUsername');
    const password = localStorage.getItem('savedPassword');
    const isRemember = localStorage.getItem('isRemember');

    if (username && password && isRemember === 'YES') {
      form.setFieldsValue({
        username: username || '',
        password: password || '',
        remember: true,
      });
    }
  }, [form]);

  useEffect(() => {
    if (isError) {
      Toast(api, 'Error', message);
      clearLoginRequest();
      return;
    }

    if (isSuccess && userInfo?.user_should_login) {
      Toast(api, 'Success', message);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('newLogin', 'YES');
      setIsAdminFirstLogin(false);
      setIsUserFirstLogin(false);
      form.resetFields();

      if (
        userInfo.is_admin &&
        userInfo?.user?.user_role_id === isAdminAccount
      ) {
        navigate(urls.dashboard);
        window.location.reload();
        return;
      }

      if (
        !userInfo.is_admin &&
        userInfo?.user?.user_role_id !== isAdminAccount
      ) {
        if (isLoadingPermission) {
          return;
        }

        const filterUserPermissions = userPermission?.filter(
          (item: { role_id: number }) =>
            item?.role_id === userInfo?.user?.user_role_id
        );

        if (!filterUserPermissions || filterUserPermissions.length === 0) {
          navigate(urls.pageNotFound);
          window.location.reload();
          return;
        }

        const firstPermittedPage = pageFeatures.find((page) =>
          filterUserPermissions.some(
            (permission: { feature: string; is_allowed: true }) =>
              permission.feature.toLowerCase() === page.feature &&
              permission?.is_allowed
          )
        );

        if (firstPermittedPage) {
          navigate(firstPermittedPage.url);
          window.location.reload();
          return;
        }

        navigate(urls.pageNotFound);
        window.location.reload();
      }
    }
  }, [
    message,
    isError,
    userInfo,
    refreshToken,
    accessToken,
    userPermission,
    userInfo?.user,
    isLoadingPermission,
  ]);

  useEffect(() => {
    if (isUserFirstLogin && isSuccess) {
      form.resetFields();
      clearLoginRequest();
    }
  }, [isSuccess, isUserFirstLogin]);

  useEffect(() => {
    if (userInfo?.is_admin && userInfo?.provide_otp) {
      setIsAdminFirstLogin(true);
    }

    if (!userInfo?.is_admin && userInfo?.update_credentials) {
      setIsUserFirstLogin(true);
    }
  }, [userInfo]);

  return (
    <LoginPage
      onHandleSubmit={onHandleSubmit}
      form={form}
      contextHolder={contextHolder}
      loading={loading}
      countryList={countryList}
      setSelectedCountry={setSelectedCountry}
      selectedCountry={selectedCountry}
      isAdminFirstLogin={isAdminFirstLogin}
      isUserFirstLogin={isUserFirstLogin}
    />
  );
};

export default LoginPageContainer;
